/**
 * Maps a Bugsnag Event to a normalized error object for PostHog.
 *
 * @param {import('@bugsnag/js').Event} event
 * @param {Record<string, any>} extraContext
 * @returns {Object} A PostHog-compatible error event payload
 */
export function mapBugsnagEventToPosthogErrorPayload(event) {
  const error = event.errors?.[0];

  const stack = error?.stacktrace
    ?.map(
      (frame) =>
        `${frame.method} (${frame.file}:${frame.lineNumber}:${frame.columnNumber})`
    )
    .join("\n");

  return {
    name: error?.errorClass,
    message: error?.errorMessage,
    stack,
    componentStack: event.context,
    severity: event.severity,
    releaseStage: event.app?.releaseStage,
    appVersion: event.app?.version,
  };
}
